  (function () {
    const spacerId = 'SkaiiyBreadcrumbHeaderSpacer';
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    let resizeObserver = null;
    let mutationObserver = null;
    let observedHeader = null;
    let animationFrame = null;

    function isVisible(element) {
      if (!element || !(element instanceof Element)) return false;

      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();

      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        Number.parseFloat(style.opacity || '1') > 0 &&
        rect.width > 0 &&
        rect.height > 0
      );
    }

    function findHeader() {
      const selectors = [
        '.header-wrapper',
        'sticky-header.header-wrapper',
        'sticky-header',
        '#shopify-section-header .header',
        '.shopify-section-header .header',
        'header.header',
        'header[role="banner"]',
        '#shopify-section-header',
        '.shopify-section-header'
      ];

      for (const selector of selectors) {
        const elements = document.querySelectorAll(selector);

        for (const element of elements) {
          if (!isVisible(element)) continue;

          const rect = element.getBoundingClientRect();

          /* Ignore small icons, drawers and full-screen overlays. */
          if (rect.width < window.innerWidth * 0.7) continue;
          if (rect.height < 36 || rect.height > 180) continue;

          return element;
        }
      }

      return null;
    }

    function breadcrumbTextMatches(element) {
      const text = (element.textContent || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase();

      if (!text.includes('HOME')) return false;

      return (
        text.includes('SHOP BY ANIME') ||
        text.includes('JUJUTSU KAISEN') ||
        text.includes('BREADCRUMB')
      );
    }

    function findBreadcrumbElement() {
      const directSelectors = [
        'nav[aria-label*="breadcrumb" i]',
        '[data-breadcrumbs]',
        '[data-breadcrumb]',
        '.breadcrumbs',
        '.breadcrumb',
        '.breadcrumb-wrapper',
        '.breadcrumbs-wrapper',
        '.breadcrumb-container',
        '.breadcrumbs-container',
        '[id*="breadcrumb" i]',
        '[class*="breadcrumb" i]'
      ];

      for (const selector of directSelectors) {
        const elements = document.querySelectorAll(selector);

        for (const element of elements) {
          if (isVisible(element) && breadcrumbTextMatches(element)) {
            return element;
          }
        }
      }

      /* Fallback for breadcrumb sections that use completely custom class names. */
      const candidates = Array.from(
        document.querySelectorAll('nav, [role="navigation"], ol, ul, div')
      )
        .filter(function (element) {
          if (!isVisible(element) || !breadcrumbTextMatches(element)) return false;
          if (element.closest('.menu-drawer, .search-modal, .cart-drawer, dialog')) return false;

          const rect = element.getBoundingClientRect();
          return rect.height <= 140 && rect.width >= window.innerWidth * 0.65;
        })
        .sort(function (first, second) {
          const firstRect = first.getBoundingClientRect();
          const secondRect = second.getBoundingClientRect();
          const firstScore = firstRect.height * 1000 + (first.textContent || '').length;
          const secondScore = secondRect.height * 1000 + (second.textContent || '').length;
          return firstScore - secondScore;
        });

      return candidates[0] || null;
    }

    function getBreadcrumbSection(element) {
      if (!element) return null;

      const section = element.closest('[id^="shopify-section-"]');

      if (section && isVisible(section)) {
        const rect = section.getBoundingClientRect();
        const text = (section.textContent || '').replace(/\s+/g, ' ').trim();

        /* Use the Shopify section wrapper only when it contains just the breadcrumb row. */
        if (rect.height <= 150 && text.length <= 220) return section;
      }

      let target = element;

      while (target.parentElement) {
        const parent = target.parentElement;

        if (
          parent === document.body ||
          parent === document.documentElement ||
          parent.matches('main, header, sticky-header, .header-wrapper')
        ) {
          break;
        }

        const targetRect = target.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        const parentText = (parent.textContent || '').replace(/\s+/g, ' ').trim();

        if (
          parentRect.height <= Math.max(150, targetRect.height + 50) &&
          parentRect.width >= window.innerWidth * 0.7 &&
          parentText.length <= 220
        ) {
          target = parent;
          continue;
        }

        break;
      }

      return target;
    }

    function removeSpacer() {
      const spacer = document.getElementById(spacerId);
      if (spacer) spacer.remove();
    }

    function watchHeader(header) {
      if (!('ResizeObserver' in window)) return;
      if (header === observedHeader) return;

      if (resizeObserver) resizeObserver.disconnect();

      observedHeader = header;
      resizeObserver = new ResizeObserver(scheduleUpdate);

      if (header) resizeObserver.observe(header);
    }

    function applySpacing() {
      animationFrame = null;

      if (!mobileQuery.matches) {
        removeSpacer();
        return;
      }

      const header = findHeader();
      const breadcrumb = getBreadcrumbSection(findBreadcrumbElement());

      if (!header || !breadcrumb || !breadcrumb.parentNode) {
        removeSpacer();
        return;
      }

      const headerHeight = Math.max(
        0,
        Math.ceil(header.getBoundingClientRect().height)
      );

      if (!headerHeight) {
        removeSpacer();
        return;
      }

      let spacer = document.getElementById(spacerId);

      if (!spacer) {
        spacer = document.createElement('div');
        spacer.id = spacerId;
        spacer.setAttribute('aria-hidden', 'true');
      }

      if (spacer.parentNode !== breadcrumb.parentNode || spacer.nextSibling !== breadcrumb) {
        breadcrumb.parentNode.insertBefore(spacer, breadcrumb);
      }

      spacer.style.setProperty('display', 'block', 'important');
      spacer.style.setProperty('width', '100%', 'important');
      spacer.style.setProperty('height', headerHeight + 'px', 'important');
      spacer.style.setProperty('min-height', headerHeight + 'px', 'important');
      spacer.style.setProperty('max-height', headerHeight + 'px', 'important');
      spacer.style.setProperty('flex', '0 0 ' + headerHeight + 'px', 'important');
      spacer.style.setProperty('margin', '0', 'important');
      spacer.style.setProperty('padding', '0', 'important');
      spacer.style.setProperty('border', '0', 'important');
      spacer.style.setProperty('background', 'transparent', 'important');
      spacer.style.setProperty('pointer-events', 'none', 'important');

      breadcrumb.setAttribute('data-skaiiy-breadcrumb-spacing-target', 'true');
      watchHeader(header);
    }

    function scheduleUpdate() {
      if (animationFrame !== null) cancelAnimationFrame(animationFrame);
      animationFrame = requestAnimationFrame(applySpacing);
    }

    function initialise() {
      scheduleUpdate();

      window.addEventListener('load', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate, { passive: true });
      window.addEventListener('orientationchange', scheduleUpdate, { passive: true });
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      mobileQuery.addEventListener?.('change', scheduleUpdate);
      document.addEventListener('shopify:section:load', scheduleUpdate);
      document.addEventListener('shopify:section:reorder', scheduleUpdate);

      if ('MutationObserver' in window) {
        mutationObserver = new MutationObserver(scheduleUpdate);
        mutationObserver.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'hidden', 'style']
        });
      }
    }

    if (!window.__skaiiyBreadcrumbHeaderSpacerInitialised) {
      window.__skaiiyBreadcrumbHeaderSpacerInitialised = true;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialise, { once: true });
      } else {
        initialise();
      }
    } else {
      scheduleUpdate();
    }
  })();
